import dayjs from "dayjs";
import { DATE_FORMAT } from "./constants/common";

export const formatDate = (
  date: string,
  format: string = DATE_FORMAT.JP_DATE,
) => {
  return dayjs(date).format(format);
};
